import * as React from 'react';
import { isMobile } from 'react-device-detect';

import Badge from '@/components/elements/Badge';
import Button from '@/components/elements/Button/BaseButton';

import { ButtonWrapper, Container } from './style';

interface BetListProps {
  children: React.ReactNode;
  isBettable: boolean;
  addable: boolean;
  setIsShowModal: (bool: boolean) => void;
  modifyKey: string;
  addToBetPanel: () => void;
  cancelModifyFn: () => void;
  ticketCount: number;
}

const BetList: React.FC<BetListProps> = ({
  children,
  isBettable,
  addable,
  setIsShowModal,
  modifyKey,
  addToBetPanel,
  cancelModifyFn,
  ticketCount,
}) => {
  return (
    <Container>
      <>{children}</>
      <ButtonWrapper>
        <Button
          data-testid="add-to-bet-panel-btn"
          size="m"
          bgColor="primary"
          fontWeight="bold"
          radius="l"
          height="56px"
          disabled={!isBettable || !addable}
          onClick={() => addToBetPanel()}
        >
          {modifyKey ? '修正を完了する' : '投票パネルへ追加する'}
        </Button>
        {Boolean(modifyKey) && (
          <Button
            data-testid="cancel-modify-btn"
            size="m"
            bgColor="darkGray"
            fontWeight="bold"
            radius="l"
            height="56px"
            outline
            onClick={() => cancelModifyFn()}
          >
            修正を取り消す
          </Button>
        )}
        {!isMobile && (
          <Badge
            isShow={Boolean(ticketCount)}
            hasCount
            count={ticketCount}
            top="-10px"
            right="-10px"
            style={{ width: '100%' }}
          >
            <Button
              data-testid="show-bet-panel-btn"
              size="m"
              bgColor="primary"
              outline
              fontWeight="bold"
              radius="l"
              height="56px"
              disabled={!isBettable}
              onClick={() => setIsShowModal(true)}
            >
              投票パネルを見る
            </Button>
          </Badge>
        )}
      </ButtonWrapper>
    </Container>
  );
};

export default BetList;
